import { Grid, Box, Typography, Button } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import personajes from "../../../Recursos/opiniones.svg";
import { useResponsive } from "../../../Modulo_Responsive/Hooks/useResponsive";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase/firebase";
import StarIcon from "@mui/icons-material/Star";

const GOOGLE_MAPS_URL =
    "https://www.google.com/search?sca_esv=954a16bda8dfd6ee&sxsrf=ANbL-n5iHeKMVr2u2TlaolU4vINvznT50w:1775839524778&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOZ4YlSCSA5hzU9dU-awmI1a2AjWhqWMObEfKu2w2_1duT7DD77rQ35S0GbZYXE6TH1W1xmPNFfSnKWVf28uOcqbWj2nokuK7dNnfIkubim3yj8nmDg%3D%3D&q=Toppings+/+salchipapas+Opiniones&sa=X&ved=2ahUKEwjpvLXg3eOTAxXBQzABHSiDN_4Q0bkNegQIGRAH&biw=1707&bih=917&dpr=1.13#lrd=0x8e2f339aabe6a381:0xebdd4d8b5626455f,3,,,,";

const Opiniones = () => {
    const { sCell } = useResponsive();
    const [imagenOpiniones, setImagenOpiniones] = useState(null);

    useEffect(() => {
        const unsub = onSnapshot(doc(db, "configuracion", "textos"), (snap) => {
            if (snap.exists()) {
                const data = snap.data();
                setImagenOpiniones(data.opiniones_imagen || null);
            }
        });
        return () => unsub();
    }, []);

    return (
        <>
            <Helmet>
                <title>Opiniones y Sugerencias - Nombre de tu Página</title>
                <meta name="description" content="Déjanos tu opinión o sugerencia sobre nuestros productos y servicios." />
                <meta name="keywords" content="opiniones, sugerencias, comentarios, feedback, clientes, experiencia" />
                <meta property="og:title" content="Opiniones y Sugerencias - Nombre de tu Página" />
                <meta property="og:description" content="Déjanos tu opinión o sugerencia sobre nuestros productos y servicios." />
                <meta property="og:image" content={imagenOpiniones || personajes} />
                <meta property="og:type" content="website" />
            </Helmet>

            <Grid container justifyContent={"center"} alignItems={"center"} size={{ xs: 12 }}>
                <Grid container justifyContent="center" size={{ xs: 12 }} sx={{ maxWidth: "1400px" }}>

                    {/* ── Imagen o texto predeterminado ── */}
                    {imagenOpiniones ? (
                        <Grid container justifyContent={"center"} size={{ xs: 12 }} sx={{ py: 2 }}>
                            <Box
                                component="img"
                                src={imagenOpiniones}
                                alt="Opiniones y sugerencias"
                                sx={{ width: { xs: "100%", md: "50%" }, height: "auto" }}
                            />
                        </Grid>
                    ) : (
                        <>
                            <Grid container justifyContent={"center"} size={{ xs: 12 }} sx={{ maxWidth: "1400px", px: 3, py: 3 }}>
                                <Typography
                                    component="h2"
                                    sx={{
                                        fontSize: sCell ? 32 : 48,
                                        fontWeight: 600,
                                        fontFamily: "Abril Fatface",
                                        textAlign: "center",
                                        lineHeight: 1.2,
                                    }}
                                >
                                    Nos importa mucho lo que piensas
                                </Typography>
                            </Grid>

                            <Grid container justifyContent={"center"} size={{ xs: 12 }} sx={{ pt: 2 }}>
                                <Typography component="p" sx={{ fontSize: 16, fontWeight: 400, textAlign: "center" }}>
                                    Te agradecemos una opinión o sugerencia
                                </Typography>
                            </Grid>
                        </>
                    )}

                    {/* ── Botón Google Maps ── */}
                    <Grid
                        container
                        justifyContent={"center"}
                        alignItems={"center"}
                        size={{ xs: 12 }}
                        sx={{ px: 3, pt: 3, pb: 4 }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            startIcon={<StarIcon />}
                            href={GOOGLE_MAPS_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                borderRadius: 4,
                                px: 4,
                                py: 1.5,
                                fontSize: 16,
                                fontWeight: 600,
                                textTransform: "none",
                            }}
                        >
                            ¡Cuéntanos tu experiencia!
                        </Button>
                    </Grid>

                </Grid>
            </Grid>
        </>
    );
};

export default Opiniones;
